module.exports = __webpack_public_path__ + "static/dashboardImage-2b7f6fbbf4ebda0654ac26f56e7f3817.png";